const history = window.history.length;
const origin = window.location.origin;
$('.js-appClose').on('click', () => {
    (history > 2) ? window.history.back() : window.location.href = origin;
})
